import React, {useEffect, useMemo} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MemberCode from './MemberCode';
import ActivationCode from './components/ActivationCode';

function App() {

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('debug') === 'debug') {
      // 动态导入 vConsole（避免打包进生产代码）
      import('vconsole').then(({ default: VConsole }) => {
        // 防止重复初始化
        if (!window.vConsole) {
          window.vConsole = new VConsole();
        }
      });
    }
  }, []);

  const showICP = useMemo(() => {
    const host = window.location.hostname || '';
    return host.endsWith('huazai.cc') || host.includes("localhost") || host.includes("127.0.0.1");
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/member" element={<MemberCode />} />
          <Route path="/activate" element={<ActivationCode />} />
          <Route path="/" element={<Navigate to="/member" replace />} />
        </Routes>
        {showICP && (
          <div className="icp-footer">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">浙ICP备2023012191号-4</a>
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;
